import { LinkId } from '../../../../common/AnalyticsContext/LinkId';
import { safeMemo } from '../../../../common/util/safeMemo';
import { OptionList } from './RadioGroup.styles';
import { RadioOption } from './RadioOption/RadioOption';

interface Props<T> {
  readonly radioGroupName: string;
  readonly options: readonly Option<T>[];
  readonly value?: T;
  readonly onChange: Setter<T>;
  /** display options in rows (2 in a row) */
  readonly row?: boolean;
  readonly trackingId?: LinkId;
}

export type Option<T> = {
  readonly label: string;
  readonly description?: string;
  readonly value: T;
};

export const RadioGroup = safeMemo(
  <T,>({ radioGroupName, options, value, onChange, row, trackingId }: Props<T>) => (
    <OptionList row={row}>
      {options.map(option => (
        <RadioOption
          row={row}
          onClick={onChange}
          key={String(option.value)}
          option={option}
          groupName={radioGroupName}
          selected={option.value === value}
          trackingId={trackingId}
        />
      ))}
    </OptionList>
  ),
);
